import UAParser from 'ua-parser-js';

export const isMobile = () => {
  const userAgentCheck =
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|webOS|Mobile|Tablet/i.test(
      navigator.userAgent,
    );
  const screenCheck = window.innerWidth <= 800 && window.innerHeight <= 600;
  return userAgentCheck || screenCheck;
};

export function getDeviceInfo() {
  const parser = new UAParser();
  const result = parser.getResult();

  return {
    custom_order_device_browser: result.browser.name,
    custom_order_device_browser_version: result.browser.version,
    custom_order_device_os: result.os.name,
    custom_order_device_os_version: result.os.version,
    custom_order_device_type: result.device.type || 'desktop', // Default to 'desktop' if not specified
    custom_order_device_user_agent: navigator.userAgent,
  };
}
